import { Module } from '../Module';
import { GetPostLoginNotificationsRequest, IGetPostLoginNotificationsResult } from '../ServerApi/requests/GetPostLoginNotificationsRequest';
import { ModalService, ModalSize } from './ModalService';
import { ServerService } from './ServerService';


interface IPostLoginNotificationScope extends ng.IScope {
  notificationsUrl: any;
}

export class PostLoginNotifications {

  private notificationsEnabled: boolean;
  private notificationsShown: boolean; // Track whether we've already shown the notifications

  public static $inject = ['$sce', '$q', 'ModalService', '$rootScope', 'ServerService'];

  constructor(private $sce: ng.ISCEService,
              private $q: ng.IQService,
              private modal: ModalService,
              private $rootScope: ng.IScope,
              private ServerService: ServerService
  ) {
    this.notificationsShown = false;
    this.notificationsEnabled = false;
  }

  public enableNotifications(): void {
    this.notificationsEnabled = true;
  }

  public showNotificationsIfEnabled(): ng.IPromise<any> {
    if (!this.notificationsEnabled || this.notificationsShown) {
      return this.$q.when(null);
    }
    return this.fetchNotificationsUrl().then((url: string) => {

      if (url) {
        const scope = <IPostLoginNotificationScope>this.$rootScope.$new();
        scope.notificationsUrl = this.$sce.trustAsResourceUrl(url);

        return this.modal.open({
          scope: scope,
          templateUrl: 'postLoginNotifications.html',
          size: ModalSize.fitToContent
        }).result.finally(() => scope.$destroy());
      }
    }).finally(() => this.notificationsShown = true); // Suppress in case of future remounting

  }

  private fetchNotificationsUrl(): ng.IPromise<string> {
    return this.ServerService.sendRequest(new GetPostLoginNotificationsRequest())
      .then((result: IGetPostLoginNotificationsResult) => result.contentUrl);
  }

}

Module.instance().service('PostLoginNotifications', PostLoginNotifications);
